export default __webpack_public_path__ + "static/media/Tools-survey-cap60.b9bf83d0.jpeg";